import React from 'react';
import { useToken } from 'src/modules/User';
import LoadingIndicatorPage from 'src/components/LoadingIndicatorPage';
import { SubmissionPeriodTemplateWizard } from './SubmissionPeriodTemplateWizard';
import { toastError } from 'src/utils/toast';
import { useCreateForm } from '@120wateraudit/form-builder-components';

const CreateSubmissionPeriodTemplateContainer: React.FC<{ token: string }> = ({
  token
}) => {
  const { mutateAsync: createForm, isPending } = useCreateForm(token);

  return (
    <SubmissionPeriodTemplateWizard
      token={token}
      saveForm={createForm}
      isSaving={isPending}
    />
  );
};

const CreateSubmissionPeriodTemplatePage: React.FC = () => {
  const { token, isLoading } = useToken();
  if (isLoading) {
    return <LoadingIndicatorPage />;
  }
  if (!token) {
    toastError('You must be logged in to create a form.');
    return null;
  }
  return <CreateSubmissionPeriodTemplateContainer token={token} />;
};

export default CreateSubmissionPeriodTemplatePage;
